/**
 * Textos da integridade do arquivo emitido (E138, GUS-21, ADR-0094): o código registrado de cada
 * versão, a conferência de um arquivo recebido e o resultado com a referência usada. A tela fala em
 * integridade do arquivo e em correspondência com o código registrado; nunca em autoria.
 */
export const ptBRIntegridade = {
  titulo: 'Integridade do arquivo',
  versao: 'Versão {versao} · emitida em {data}',
  codigoRegistrado: 'Código registrado',
  conferir: 'Conferir um arquivo',
  conferirExplica:
    'Escolha o arquivo que você recebeu. O código dele é calculado e comparado com o código registrado da versão emitida.',
  conferindo: 'Conferindo o arquivo…',
  resultado: {
    corresponde: 'O arquivo corresponde ao código registrado',
    diverge: 'O arquivo não corresponde ao código registrado',
    sem_referencia: 'Não há código registrado para esta versão',
  },
  explicaResultado: {
    corresponde: 'O conteúdo do arquivo é o mesmo da versão registrada.',
    diverge: 'O arquivo foi alterado ou é outro documento. Não o trate como a versão emitida.',
    sem_referencia:
      'Sem código registrado, a conferência não tem com o que comparar e não confirma o arquivo.',
  },
  codigoApresentado: 'Código do arquivo apresentado',
  referenciaUsada: 'Referência usada: versão {versao} ({etapa}), emitida em {data}',
  etapa: {
    final: 'arquivo assinado',
    pre_assinatura: 'antes da assinatura',
  },
  limite:
    'A conferência mostra se o arquivo é o mesmo da versão registrada. Sozinha, não demonstra quem produziu o documento e não substitui a assinatura, a revisão nem o registro de custódia.',
  erro: {
    arquivo_vazio: 'O arquivo escolhido está vazio.',
    arquivo_grande: 'O arquivo passa do limite de 50 MB.',
    nao_encontrado: 'Esta versão não está disponível para conferência.',
    indisponivel: 'Não foi possível conferir agora. Tente novamente.',
  },
  documentos: {
    titulo: 'Documentos emitidos',
    subtitulo:
      'Cada versão emitida, com o código registrado fora do arquivo. Confira aqui um arquivo recebido.',
    vazio: 'Nenhum documento emitido neste caso.',
    erro: 'Não foi possível carregar os documentos emitidos.',
    documento: 'Documento {ccb}',
    semNumero: 'sem número',
    manifestos: '{n} manifesto(s) de recebimento na origem',
    semManifestos: 'Manifestos da origem não registrados (emissão anterior a este registro)',
    assinatura: {
      interna_registrada: 'assinatura registrada na plataforma, sem certificado ICP-Brasil',
      icp_brasil: 'assinatura ICP-Brasil',
    },
  },
  downloadDivergente:
    'O arquivo guardado não confere com o código registrado e não foi entregue. O fato ficou registrado no caso, e a equipe recupera a cópia autorizada.',
} as const;
